import { themeAtom } from "../../shared/atoms";
import { NotificationM } from "../models/notifications.models";
import { postAllNotificationsRead } from "../services/notifications.service";
import { BellRingIcon, MarkAllReadIcon } from "./NotificationIcons";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

type Props = {
  notifications: NotificationM[];
};

export const NotificationsHeader: React.FC<Props> = ({ notifications }) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className="flex items-center justify-between gap-4 px-6">
      <div className={twMerge("flex gap-2", theme.home.tailwind.textDefault)}>
        <BellRingIcon className={theme.headerComponent.tailwind.buttonText} />
        <span className="text-lg font-bold">Notifications</span>
      </div>

      {notifications.length > 0 && (
        <button
          className={twMerge("flex items-center gap-2 rounded px-4 py-2", theme.myVesselsTableRow.row.primary)}
          onClick={() => postAllNotificationsRead(notifications)}
        >
          <MarkAllReadIcon className={theme.headerComponent.tailwind.buttonText} />
          <span className={theme.headerComponent.tailwind.buttonText}>Mark all as read</span>
        </button>
      )}
    </div>
  );
};
